import { Component, OnInit } from '@angular/core';
import { UserGroupService } from "../../../services/user-group.service";
import { UserGroup } from "../../../app/app.interfaces";


@Component({
  selector: 'user-group-list',
  templateUrl: 'user-group-list.html'
})

export class UserGroupList implements OnInit{

	userGroups: UserGroup[] = [];

	constructor(private userGroupService: UserGroupService){

	}

	ngOnInit(): void{

		if(!this.userGroupService.isInitialized){
			this.userGroupService.loadUserGroups();
		}

	}

}



// WEBPACK FOOTER //
// ./src/partials/user-group/user-group-list/user-group-list.ts